import CalendarImg from "../assets/calendar.png";
import React from "react";

export default function NoUpcomingAppointment() {
  return (
    <div className="text-center py-3 px-16">
      <img
        src={CalendarImg}
        alt="calendar"
        className="block m-auto w-28 my-4"
      />
      <p className="font-bold text-lg">No upcoming appointments</p>
      <p className="text-gray-500">
        It looks like you don't have any upcoming appointments scheduled right
        now. Keep an eye on this section for your future appointments
      </p>
    </div>
  );
}
